import { vinRegex, vinNotAllowedAlphabetRegex, vinNotAllowedRegex, NewVehicleRegex } from "./regexUtils";

export const handleVehicleValidations = (field, value) => {
  let errorMsg = "";
  if (field === "vin") {
    value = value.trim()?.toUpperCase();
    if (!value) {
      errorMsg = "VIN is required";
    } else if (!vinRegex.test(value)) {
      if (vinNotAllowedRegex.test(value)) {
        return false; //if the value contains any special characters other than alphabets and digits, then return false
      } else if (vinNotAllowedAlphabetRegex.test(value)) {
        errorMsg = "VIN must not contain the letters I, O, or Q";
      }
    } else if (value.length !== 17) {
      errorMsg = "VIN must contain 17 characters";
    }
  } else if (field === "vehicleName") {
    if (!value) {
      errorMsg = "New vehicle or powered asset name is required";
    } else if (!NewVehicleRegex.test(value)) {
      return false; //if the value is not matching the regex, then return
    }
  }
  return { isValid: !errorMsg, errorText: errorMsg, value };
};
